import React from 'react';
import './SuccessModal.css';

function SuccessModal({ course, onClose }) {
  if (!course) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="success-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>×</button>
        
        <div className="success-icon">✓</div>
        
        <h2 className="success-title">Enrollment Successful!</h2>
        
        <p className="success-message">
          You have successfully enrolled in <strong>{course.title}</strong>
        </p>
        
        <div className="next-steps">
          <h3>Next Steps:</h3>
          <ol>
            <li>Check your email for course access details</li>
            <li>Complete the assigned projects</li>
            <li>Submit your work for review</li>
            <li>Receive your certificate upon completion</li>
          </ol>
        </div>
        
        <button className="done-button" onClick={onClose}>
          Got it!
        </button>
      </div>
    </div>
  );
}

export default SuccessModal;
